export const GUIDE = [
  {
    id: "inicio", title: "1. Primeiros passos",
    steps: [
      "Acesse a plataforma com o e-mail e senha da sua empresa. O primeiro usuário é o administrador.",
      "No topo, confira o nome da sua empresa. À direita ficam seu perfil e a opção de sair.",
      "Use o menu lateral para navegar entre os módulos (Painel, Pacientes, Novo Orçamento, etc.).",
      "Para trocar sua senha, clique no seu perfil (canto superior direito) e escolha 'Alterar senha'.",
      "Empresas em teste têm 14 dias grátis; após pagar a mensalidade, o acesso é renovado automaticamente.",
      "Precisa de ajuda? Toque no balão verde 'Ajuda', no canto inferior da tela, para falar com o suporte RotaSaúde pelo WhatsApp.",
    ],
  },
  {
    id: "painel", title: "2. Painel (visão do mês)",
    steps: [
      "Em 'Painel' você vê a visão operacional do mês corrente da sua empresa.",
      "Indicadores: Remoções do mês, Faturamento realizado, Km rodados, Lucro estimado, Orçamentos pendentes e Remoções agendadas.",
      "O faturamento considera apenas as remoções marcadas como 'Realizada'.",
      "Quando houver eventos futuros, aparece a lista 'Próximos eventos agendados' com data, local e valor.",
    ],
  },
  {
    id: "empresa", title: "3. Minha Empresa (identidade dos documentos)",
    steps: [
      "Abra 'Minha Empresa' no menu.",
      "Preencha nome, telefone/WhatsApp, e-mail e CNPJ — esses dados aparecem nos orçamentos e recibos.",
      "Envie o logo da sua empresa: ele aparece ao lado da marca RotaSaúde nos PDFs e também no link do motorista. O nome e o CNPJ ainda vão no texto do orçamento enviado pelo WhatsApp.",
      "Ajuste o rodapé do orçamento e clique em 'Salvar identidade'.",
    ],
  },
  {
    id: "usuarios", title: "4. Usuários e perfis de acesso",
    steps: [
      "Em 'Usuários', cadastre a equipe que vai usar o sistema.",
      "Perfis: Administrador (acesso total), Operacional (orçamentos e rotas), Financeiro (financeiro e relatórios).",
      "Cada usuário entra com o próprio e-mail e senha; os dados ficam isolados por empresa.",
    ],
  },
  {
    id: "profissionais", title: "5. Profissionais e Frota",
    steps: [
      "Em 'Profissionais', cadastre cada profissional/especialidade (ex.: motorista, enfermeiro, cuidador, fisioterapeuta) com o valor padrão — usado no cálculo do orçamento.",
      "Em 'Frota', cadastre os veículos/ambulâncias com nome, consumo médio (km/L), preço do combustível (R$/L) e placa/observação. Consumo e combustível entram no custo da viagem.",
      "Ainda em 'Frota', registre as manutenções (veículo, data, tipo e valor), que entram como custo no Financeiro.",
    ],
  },
  {
    id: "pacientes", title: "6. Pacientes",
    steps: [
      "Em 'Pacientes', cadastre a família/responsável e o paciente com telefone/WhatsApp, idade, altura, peso, uso de medicamentos e observações clínicas.",
      "Clique em 'Usar no orçamento' ao lado do paciente para abrir o Novo Orçamento já com a família e o telefone preenchidos.",
    ],
  },
  {
    id: "orcamento", title: "7. Novo Orçamento (passo a passo)",
    steps: [
      "Abra 'Novo Orçamento'.",
      "Escolha o 'Tipo de serviço' (Remoção, Traslado hospitalar, Consulta/Dentista, Aeroporto, Rodoviária, Alta hospitalar, Busca em residência ou Outro).",
      "Escolha o 'Tipo de rota': '3 pontos' (Origem → Paciente → Clínica) para remoção, ou 'Ponto a ponto' (Origem → Destino) para traslados simples.",
      "Preencha origem, destino e (se for o caso) a clínica. Digite o CEP e o 'Nº' do endereço e clique em 'Buscar' para preencher o endereço completo; se mudar o Nº depois, o endereço é atualizado sozinho.",
      "Clique em 'Calcular automaticamente' para trazer distância, tempo e pedágio reais do Google Maps — ou informe os km manualmente.",
      "Selecione o veículo, o 'Tipo p/ pedágio' (define os eixos no cálculo do pedágio) e marque a equipe que vai atender (com quantidade).",
      "Clique em 'Continuar para custos e orçamento'.",
      "Revise custos (combustível, pedágios, equipe) e a margem/preço. Você pode voltar à rota a qualquer momento — os dados ficam salvos entre as telas.",
      "Clique em 'Salvar orçamento', 'Gerar PDF', ou use 'WhatsApp' / 'Copiar texto' para mandar ao cliente.",
    ],
  },
  {
    id: "meus-orcamentos", title: "8. Meus Orçamentos e conversão em remoção",
    steps: [
      "Em 'Meus Orçamentos' você vê todos os orçamentos e o status de cada um (Orçamento, Aprovado, Agendado, Em andamento, Realizado, Recusado ou Cancelado).",
      "Quando o cliente aceitar, mude o status para 'Aprovado'.",
      "Clique em 'Converter em Remoção' — só então a viagem aparece em 'Rotas e Viagens'. (Aprovar não cria a remoção sozinho.)",
      "Use 'Editar' para reabrir o orçamento (CEP, Nº e endereços voltam preenchidos), 'PDF' para baixar e 'Excluir' para apagar. Para reenviar pelo WhatsApp, abra em 'Editar', avance para custos e use o botão 'WhatsApp'.",
    ],
  },
  {
    id: "rotas", title: "9. Rotas e Viagens + link do motorista",
    steps: [
      "Em 'Rotas e Viagens' ficam as remoções agendadas e realizadas, com o tipo de serviço indicado.",
      "Clique em 'Copiar link do motorista' (ou 'Enviar no WhatsApp'): o motorista abre o link no celular, vê o trajeto e ativa a localização. O link mostra o logo, nome e CNPJ da sua empresa.",
      "Use 'Acompanhar ao vivo' para ver a posição do motorista no mapa em tempo real.",
      "Status da remoção: Agendada, Em andamento, Realizada ou Cancelada. Ao concluir, mude para 'Realizada' — assim a viagem entra no faturamento do mês.",
      "Se precisar apagar um teste ou engano, use 'Excluir' (apenas administrador): a remoção sai de Rotas, Rastreamento e Financeiro.",
    ],
  },
  {
    id: "rastreamento", title: "10. Rastreamento da frota",
    steps: [
      "Em 'Rastreamento' você vê no mapa os veículos que estão com viagem em andamento.",
      "A posição é atualizada automaticamente; se o motorista ficar sem sinal, os pontos são enviados assim que a conexão voltar.",
    ],
  },
  {
    id: "eventos", title: "11. Eventos (cobertura de ambulância)",
    steps: [
      "Em 'Eventos' (administrador) cadastre coberturas em festas, shows e eventos.",
      "Informe local, datas, valor recebido e os custos (equipe, deslocamento, alimentação, hospedagem, outros).",
      "Clique em 'Marcar realizado' para somar ao faturamento do mês.",
      "Use 'Duplicar' para repetir um evento em nova data, 'Contrato' para gerar a proposta ao cliente e 'PDF' para o resumo interno.",
    ],
  },
  {
    id: "servicos", title: "12. Serviços (telemedicina, hospitais e convênios)",
    steps: [
      "Em 'Serviços' (administrador e financeiro), abra 'Clientes' e cadastre hospitais, convênios, clínicas e outros contratantes com CPF/CNPJ e endereço (use 'Buscar' pelo CEP).",
      "Em 'Serviços prestados', clique em 'Novo serviço': escolha o cliente, o tipo (telemedicina, plantão, home care etc.), a data, o valor cobrado, os custos e a situação (A receber ou Pago).",
      "Os serviços do mês (exceto cancelados) entram no Financeiro e no fechamento mensal em PDF, numa seção própria. No topo você vê faturado, recebido, a receber e lucro do mês.",
      "Use 'Marcar pago' quando receber e 'Recibo' para gerar o recibo numerado em PDF com o logo da sua empresa.",
      "Em 'Por cliente', escolha o mês e veja quanto cada hospital ou convênio gerou, quanto já pagou e quanto falta receber; use 'PDF para cobrança' para enviar ao cliente.",
      "Nota fiscal: em 'Nota fiscal', o administrador cola o token da sua conta Focus NFe e preenche os dados fiscais (CNPJ, inscrição municipal, código IBGE, item de serviço e alíquota do ISS). Comece em 'Homologação' para testar.",
      "Com a emissão ativada, clique em 'Emitir nota' no serviço; use 'Atualizar situação' até aparecer 'Nota autorizada' e então 'Ver nota (PDF)'. Se emitir a nota fora do sistema, anote o número no campo 'Nº da nota emitida fora do sistema'.",
    ],
  },
  {
    id: "financeiro", title: "13. Financeiro",
    steps: [
      "Em 'Financeiro' acompanhe faturamento, custos, lucro e margem do mês.",
      "Considera as remoções marcadas como 'Realizada', os eventos 'Realizado' e os serviços do mês (pagos e a receber).",
      "Escolha o mês e clique em 'Fechamento mensal em PDF', que inclui a movimentação e seções separadas de eventos e de serviços.",
    ],
  },
  {
    id: "assinatura", title: "14. Assinatura e pagamento",
    steps: [
      "Em 'Assinatura' escolha o plano (Essencial, Profissional ou Premium) conforme sua operação.",
      "Pague a mensalidade por cartão/boleto (link do Mercado Pago) ou por PIX (QR Code na hora).",
      "No PIX, o app mostra o tempo de validade do QR Code e confirma o pagamento na tela automaticamente.",
      "Após pagar, o status fica 'Ativa' e a 'Próxima cobrança' é calculada a partir do fim do teste. Os recibos ficam disponíveis para download.",
    ],
  },
];

const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

function printGuide(comp) {
  const c = comp || {};
  const wa = String(c.phone || "").replace(/\D/g, "");
  const waNum = wa && !wa.startsWith("55") ? `55${wa}` : wa;
  const logo = c.logo ? `<img src="${esc(c.logo)}" alt="Logo" style="max-height:60px;max-width:160px;object-fit:contain">` : "";
  const head = `<div class="brand">${logo}<div><strong>${esc(c.name || "RotaSaúde")}</strong>${c.doc ? `<small>CNPJ: ${esc(c.doc)}</small>` : ""}</div>${waNum ? `<a class="wa" href="https://wa.me/${waNum}" target="_blank">Falar no WhatsApp</a>` : ""}</div>`;
  const w = window.open("", "_blank");
  if (!w) { alert("Permita pop-ups para gerar o PDF do guia."); return; }
  const sections = GUIDE.map((s) => `<div class="sec"><h2>${s.title}</h2><ol>${s.steps.map((t) => `<li>${t}</li>`).join("")}</ol></div>`).join("");
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Guia RotaSaúde</title><style>@page{size:A4;margin:16mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#17324f;margin:0}.brand{display:flex;align-items:center;gap:14px;margin-bottom:12px}.brand div{display:flex;flex-direction:column}.brand strong{font-size:16px;color:#0b477d}.brand small{font-size:11px;color:#516b82}.wa{margin-left:auto;background:#19b95b;color:#fff;text-decoration:none;font-weight:700;font-size:12px;padding:8px 14px;border-radius:8px;-webkit-print-color-adjust:exact;print-color-adjust:exact}h1{color:#0b477d;border-bottom:3px solid #0d5b9d;padding-bottom:10px}.sec{margin:16px 0;break-inside:avoid}.sec h2{color:#0b477d;font-size:15px;margin:0 0 6px}ol{margin:0;padding-left:20px}li{font-size:12px;line-height:1.6;margin-bottom:4px}.foot{margin-top:22px;padding-top:10px;border-top:1px solid #dbe6ee;font-size:9px;color:#6d8094;text-align:center}</style></head><body>${head}<h1>Guia de uso — RotaSaúde</h1><p style="font-size:12px;color:#516b82">Passo a passo de todas as funcionalidades da plataforma.</p>${sections}<div class="foot">RotaSaúde — Planejamento que leva cuidado até você • Gerado em ${new Date().toLocaleDateString("pt-BR")}</div><script>window.onload=()=>setTimeout(()=>window.print(),400)<\/script></body></html>`);
  w.document.close();
}

export default function AjudaTab({ comp }) {
  return (
    <section className="panel active">
      <div className="module-head">
        <div><h1>Ajuda / Guia</h1><p>Passo a passo de todas as funcionalidades da plataforma. Compartilhe com sua equipe.</p></div>
        <button className="primary" onClick={() => printGuide(comp)} data-testid="btn-print-guide">Imprimir / Salvar PDF</button>
      </div>
      <div className="module-list">
        {GUIDE.map((s) => (
          <article className="card" key={s.id} data-testid={`guide-${s.id}`} style={{ marginBottom: 14 }}>
            <h2>{s.title}</h2>
            <ol style={{ margin: "8px 0 0", paddingLeft: 20, color: "#3a4f63", fontSize: 14, lineHeight: 1.7 }}>
              {s.steps.map((t, i) => <li key={i}>{t}</li>)}
            </ol>
          </article>
        ))}
      </div>
    </section>
  );
}
